module.exports = __webpack_public_path__ + "static/media/camera.0d2fe60c.svg";